// @core/api/endpoints/license/get_public_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPublicKeyResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Get public signing key
 * Returns the current public key (Ed25519) used for offline license signature verification. Local instances use this to validate licenses without contacting master.
 * @public This endpoint does not require authentication
 */
export async function GetPublicKey(
  params?: {
  },
  options?: RequestOptions
): Promise<GetPublicKeyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/licenses/signing-keys/public`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetPublicKeyResponse>(requestPath, { ...requestOptions, params });
}
